module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vertical-tab-pane",
    class: {
      active: _vm.active
    },
    on: {
      "click": function($event) {
        _vm.select()
      }
    }
  }, [_vm._v("\n  " + _vm._s(_vm.label) + "\n  "), _c('div', {
    staticClass: "tab-right"
  }, [_vm._t("right")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-3a770971"}!./~/.11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/form/VerticalTabPane.vue
// module id = 160
// module chunks = 1